/** Fixed destinations: campaign entry never takes navigation targets from a URL. */
export const SUPER_HERO_CAMPAIGN_ID = 'tli52e2n5tyjjp47e7encgqi';
export const SUPER_HERO_ENTRY_PATH = '/super-hero';
export const SUPER_HERO_CAMPAIGN_PATH = `/campaigns/${SUPER_HERO_CAMPAIGN_ID}`;
export const SUPER_HERO_BANNER_URL = 'https://storage.autoclipper.live/cpm-campaign-banners/tli52e2n5tyjjp47e7encgqi-pdf-original-v1.jpg';
export const SUPER_HERO_LOGO_URL = 'https://storage.autoclipper.live/cpm-campaign-logos/tli52e2n5tyjjp47e7encgqi-v1.jpg';
